export default {
  USED: {
    value: 'USED',
    label: '已使用',
  },
  UNUSED: {
    value: 'UNUSED',
    label: '未使用',
  },
}